/** Ékezet- és kisbetű-független összehasonlítás magyar/szlovák szövegekhez. */
export function foldText(value: string): string {
  return value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();
}

export function tokenize(value: string): string[] {
  return foldText(value).split(" ").filter(Boolean);
}
